"use client";
type TabValue = "1 ZEC" | "10 ZEC" | "100 ZEC" | "1000 ZEC";
interface ConverterTabsProps {
  activeTab: TabValue;
  onTabChange: (tab: TabValue) => void;
}
const tabs: TabValue[] = ["1 ZEC", "10 ZEC", "100 ZEC", "1000 ZEC"];

export default function ConverterTabs({
  activeTab,
  onTabChange,
}: ConverterTabsProps): React.ReactElement {
  const activeIndex = tabs.indexOf(activeTab);

  return (
    <div className="flex gap-0">
      {tabs.map((tab) => (
        <button
          key={tab}
          className={`px-3 sm:px-4 py-1 text-[14px] font-kode-mono cursor-pointer transition-all duration-300 ease-out
            ${tabs.indexOf(tab) !== tabs.length - 1 && activeTab !== tab ? "border-r-transparent" : ""}
            ${tabs.indexOf(tab) === tabs.indexOf(activeTab) + 1 ? "border-l-transparent" : ""}
            ${
              activeTab === tab
                ? "text-white bg-[rgba(244,183,40,0.21)] border border-[rgba(244,183,40,0.34)]"
                : "text-white bg-white/5 border border-white/10"
            }`}
          onClick={() => onTabChange(tab)}
        >
          {tab}
        </button>
      ))}
    </div>
  );
}
